import HeaderLayout from 'components/HeaderLayout/HeaderLayout';
import AuthView from 'views/AuthView/AuthView';
import ScreenSwitcher from 'views/ScreenSwitcher/ScreenSwitcher';

const NetworkTop = () => <HeaderLayout middle={<ScreenSwitcher />} right={<AuthView />} />;

export default NetworkTop;
